"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidDateDuration = exports.isValidEndDate = exports.checkNoFutureDate = exports.isFutureDate = void 0;
var date_fns_1 = require("date-fns");
var today = new Date().toISOString().split('T')[0];
/**
 * @param endDate  YYYY-MM-DD
 * @param startDate YYYY-MM-DD
 * @returns
 */
var isFutureDate = function (endDate, startDate) {
    if (startDate === void 0) { startDate = today; }
    return (0, date_fns_1.isAfter)(new Date(startDate), new Date(endDate));
};
exports.isFutureDate = isFutureDate;
/**
 * @param date YYYY-MM-DD
 * @returns
 */
var checkNoFutureDate = function (date) {
    var inFuture = (0, date_fns_1.isAfter)(new Date(date), new Date(today));
    if (inFuture)
        throw new Error('Future dates are not allowed.');
};
exports.checkNoFutureDate = checkNoFutureDate;
var isValidEndDate = function (startDate, endDate, startDateLabel, endDateLabel, required, blockName) {
    if (startDateLabel === void 0) { startDateLabel = 'Start Date'; }
    if (endDateLabel === void 0) { endDateLabel = 'End Date'; }
    if (required === void 0) { required = false; }
    if (blockName === void 0) { blockName = ''; }
    if ((!startDate || !endDate) && !required)
        return;
    var blockLabel = blockName !== '' ? "".concat(blockName, " ") : '';
    if (!startDate)
        throw new Error("validation.dateFieldMissing|".concat(blockLabel).concat(startDateLabel));
    if (!endDate)
        throw new Error("validation.dateFieldMissing|".concat(blockLabel).concat(endDateLabel));
    var isFuture = (0, exports.isFutureDate)(endDate, startDate);
    if (isFuture) {
        throw new Error("validation.dateStartAfterEnd|".concat(blockLabel).concat(startDateLabel, "|").concat(blockLabel).concat(endDateLabel));
    }
};
exports.isValidEndDate = isValidEndDate;
var isValidDateDuration = function (startDate, endDate, required, blockName, startDateLabel, endDateLabel) {
    if (startDateLabel === void 0) { startDateLabel = 'Start Date'; }
    if (endDateLabel === void 0) { endDateLabel = 'End Date'; }
    if (!startDate)
        return true;
    try {
        (0, exports.isValidEndDate)(startDate, endDate, startDateLabel, endDateLabel, required, blockName);
        return true;
    }
    catch (err) {
        return err.message;
    }
};
exports.isValidDateDuration = isValidDateDuration;
